import { useSyncExternalStore, useEffect } from 'react';
import { useMatches } from 'react-router-dom';
import { getCrumbsSnapshot, subscribeCrumbs } from '@shared/shell/crumbStore';
import { useAuth } from '@shared/auth/AuthContext';
import { useActiveSuite } from '../useActiveSuite';
import { buildCrumbs } from './buildCrumbs';
import { Crumb } from '@shared/shell/types';

export function useCrumbs(): { crumbs: Crumb[]; leafLabel: string } {
  const matches = useMatches();
  const activeSuite = useActiveSuite();
  const { tenant } = useAuth();
  const overrides = useSyncExternalStore(subscribeCrumbs, getCrumbsSnapshot, getCrumbsSnapshot);

  const crumbs = buildCrumbs(matches, activeSuite, overrides);
  const leafLabel =
    crumbs.length > 0
      ? crumbs[crumbs.length - 1].label
      : activeSuite?.name || 'Helios';

  useEffect(() => {
    if (crumbs.length > 0) {
      const suiteName = activeSuite?.name ? ` · ${activeSuite.name}` : '';
      const orgName = tenant?.name ? ` · ${tenant.name}` : '';
      document.title = `${leafLabel}${suiteName}${orgName}`;
    }
  }, [crumbs, leafLabel, activeSuite, tenant]);

  return { crumbs, leafLabel };
}
